module.exports = __webpack_public_path__ + "media/images/massage/cover-mobile@3x-fd290a684f42bec00caf5720be51809b.jpg";